export default [{
  path: '/contract',
  name: 'contract',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/contract/index')
}]
